import { useState } from 'react';
import emailjs from '@emailjs/browser';
import useFadeUp from '../hooks/useFadeUp';


emailjs.init('DozbVqJBql2vyXUv3');

const SERVICE_ID  = 'service_aahk7m6';
const TEMPLATE_ID = 'template_hgcpobq';
const PUBLIC_KEY  = 'v7yN-DAQ-k3TNr4NJ';

export default function Contact() {
  const ref = useFadeUp(0);
  const [sent, setSent]       = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);
  const [errors, setErrors]   = useState({});

  const [form, setForm] = useState({
    name: '', phone: '', email: '', destination: '',
    days: '', midweek: false, weekend: false, message: '',
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm(prev => ({ ...prev, [name]: value }));
    setErrors(prev => ({ ...prev, [name]: '' }));
  };

  const validate = () => {
    const newErrors = {};
    if (!form.name.trim())        newErrors.name        = 'שם מלא הוא שדה חובה';
    if (!form.phone.trim())       newErrors.phone       = 'טלפון הוא שדה חובה';
    if (!/^\d{9,10}$/.test(form.phone.replace(/-/g, '')))
                                  newErrors.phone       = 'מספר טלפון לא תקין';
    if (form.email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(form.email))
                                  newErrors.email       = 'כתובת מייל לא תקינה';
    if (!form.destination.trim()) newErrors.destination = 'יעד הוא שדה חובה';
    if (!form.days || form.days < 1)
                                  newErrors.days        = 'יש להזין מספר ימים';
    if (!form.midweek && !form.weekend)
                                  newErrors.timing      = 'יש לבחור לפחות אפשרות אחת';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }
    setLoading(true);
    setError(null);
    try {
      await emailjs.send(
        SERVICE_ID,
        TEMPLATE_ID,
        {
          from_name:   form.name,
          phone:       form.phone,
          email:       form.email || 'לא צוין',
          destination: form.destination,
          days:        form.days,
          timing:      [form.midweek ? 'אמצע שבוע' : '', form.weekend ? 'סוף שבוע' : ''].filter(Boolean).join(', '),
          message:     form.message || 'לא צוין',
        },
        PUBLIC_KEY
      );
      setSent(true);
    } catch (err) {
      setError('שגיאה בשליחה - נסה שוב או התקשר אלינו ישירות');
    } finally {
      setLoading(false);
    }
  };

  const inputClass = (field) =>
    `w-full px-4 py-3.5 rounded-xl font-body text-[15px] font-light
     bg-white/10 border text-white placeholder:text-white/45
     focus:outline-none focus:bg-white/15 transition-all duration-200
     ${errors[field] ? 'border-red-400' : 'border-white/20 focus:border-white/60'}`;

  return (
    <section id="contact" className="bg-brand-blue py-24 px-6">
      <div ref={ref} className="max-w-xl mx-auto text-center">
        <span className="inline-block bg-white/15 text-white/90 text-[11px] font-bold tracking-[2px] uppercase px-4 py-1.5 rounded-full mb-4">
          צור קשר
        </span>
        <h2 className="font-display font-bold text-[clamp(1.8rem,3vw,2.6rem)] leading-tight text-white mb-3">
          מוכנים לצאת לדרך?
        </h2>
        <p className="font-body font-light text-white/65 text-[1.05rem] leading-relaxed mb-10">
          השאירו פרטים ונחזור אליכם בהקדם עם הצעה מותאמת אישית
        </p>

        {sent ? (
          <div className="bg-white/10 border border-white/20 rounded-2xl p-10 text-center">
            <div className="text-5xl mb-4">✅</div>
            <p className="font-display font-bold text-white text-2xl mb-2">הפרטים נשלחו!</p>
            <p className="font-body font-light text-white/70">ניצור איתכם קשר בקרוב</p>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="flex flex-col gap-3 text-right">

            {/* שם + טלפון */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <input type="text" name="name" placeholder="שם מלא *"
                  value={form.name} onChange={handleChange} className={inputClass('name')} />
                {errors.name && <p className="text-red-300 text-xs mt-1 font-body">{errors.name}</p>}
              </div>
              <div>
                <input type="tel" name="phone" placeholder="טלפון *"
                  value={form.phone} onChange={handleChange} className={inputClass('phone')} />
                {errors.phone && <p className="text-red-300 text-xs mt-1 font-body">{errors.phone}</p>}
              </div>
            </div>

            {/* מייל */}
            <div>
              <input type="email" name="email" placeholder="כתובת מייל"
                value={form.email} onChange={handleChange} className={inputClass('email')} />
              {errors.email && <p className="text-red-300 text-xs mt-1 font-body">{errors.email}</p>}
            </div>

            {/* יעד */}
            <div>
              <input type="text" name="destination" placeholder="יעד שמעניין אתכם *"
                value={form.destination} onChange={handleChange} className={inputClass('destination')} />
              {errors.destination && <p className="text-red-300 text-xs mt-1 font-body">{errors.destination}</p>}
            </div>

            {/* ימים + תזמון */}
            <div className="grid grid-cols-2 gap-3">
              <div>
                <input type="number" name="days" min="1" placeholder="מספר ימים *"
                  value={form.days} onChange={handleChange} className={inputClass('days')} />
                {errors.days && <p className="text-red-300 text-xs mt-1 font-body">{errors.days}</p>}
              </div>
              <div>
                <div className={`flex items-center gap-4 px-4 py-3.5 rounded-xl bg-white/10 border
                  ${errors.timing ? 'border-red-400' : 'border-white/20'}`}>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" checked={form.midweek}
                      onChange={(e) => { setForm(p => ({ ...p, midweek: e.target.checked })); setErrors(p => ({ ...p, timing: '' })); }}
                      className="w-4 h-4 accent-white" />
                    <span className="font-body text-white/80 text-sm font-light">אמצע שבוע</span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" checked={form.weekend}
                      onChange={(e) => { setForm(p => ({ ...p, weekend: e.target.checked })); setErrors(p => ({ ...p, timing: '' })); }}
                      className="w-4 h-4 accent-white" />
                    <span className="font-body text-white/80 text-sm font-light">סוף שבוע</span>
                  </label>
                </div>
                {errors.timing && <p className="text-red-300 text-xs mt-1 font-body">{errors.timing}</p>}
              </div>
            </div>

            {/* הודעה */}
            <textarea rows={4} name="message" placeholder="ספרו לנו מה אתם מחפשים..."
              value={form.message} onChange={handleChange}
              className={`${inputClass('message')} resize-none`} />

            {error && <p className="font-body text-sm text-red-300 text-center">{error}</p>}

            <button type="submit" disabled={loading}
              className="w-full bg-white text-brand-blue font-display font-bold text-lg py-4 rounded-xl shadow-[0_4px_16px_rgba(0,0,0,0.15)] hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,0.2)] transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed">
              {loading ? 'שולח...' : 'שלחו פרטים ונחזור אליכם ✈️'}
            </button>
          </form>
        )}

        <div className="flex justify-center gap-8 mt-10 flex-wrap">
          {[
            { icon: '📞', text: '052-7777-174' },
            { icon: '📧', text: 'megedshamaim@gmail.com' },
            { icon: '📍', text: 'בית שמש, ישראל' },
          ].map(({ icon, text }) => (
            <div key={text} className="flex items-center gap-2 text-white/65 font-body text-sm font-light">
              <span className="text-lg">{icon}</span>
              {text}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}